<div class="menu-top-bar__container tw-flex tw-flex-col tw-items-start tw-p-0 tw-gap-0 tw-rounded-none">
  @if (desktopSubPosition() === 'TOP' && hasDesktopSubheader()) {
    <ng-container *ngTemplateOutlet="desktopSubheaderTemplate"></ng-container>
  }
  <div class="menu-top-bar__first-wrapper tw-flex tx-flex-row tw-justify-center tw-items-center tw-self-stretch tw-rounded-none">
    <div class="menu-top-bar__content tw-flex tw-items-center tw-self-stretch tw-flex-1 tw-w-full tw-p-0">
      <app-header-overflow-row
        class="tw-self-stretch"
        [items]="desktopMainItemsFlat()"
        [activeUrl]="headerActiveItemService.activeUrl()"
        [loginTemplate]="loginTpl"
        [isCasinoOpened]="isCasinoOpenedMemo"
        [isLightTheme]="isLightTheme"
        [isLoggedIn]="isLoggedIn"
        [showThemeTooltip]="true"
        [hideButtonLightMode]="themeService.hideButtonLightMode()"
        [showCrmButton]="showCrmButton"
        (itemClick)="onItemClick($event)"
        (themeToggle)="toggleTheme()"
      ></app-header-overflow-row>
    </div>
  </div>
  @if (desktopSubPosition() === 'BOTTOM' && hasDesktopSubheader()) {
    <ng-container *ngTemplateOutlet="desktopSubheaderTemplate"></ng-container>
  }

  <!-- Subheader template -->
  <ng-template #desktopSubheaderTemplate>
    <div class="menu-top-bar__second-wrapper tw-flex tw-justify-center tw-items-center tw-self-stretch tw-rounded-none">
        <div class="menu-top-bar__second-bar-content tw-flex tw-items-center tw-flex-1 tw-p-0 tw-rounded-none">
        <app-header-overflow-row
          class="tw-self-stretch"
          [items]="desktopSubItemsFlat()"
          [activeUrl]="headerActiveItemService.activeUrl()"
          [loginTemplate]="loginTpl"
          [isCasinoOpened]="isCasinoOpenedMemo"
          [isLightTheme]="isLightTheme"
          [isLoggedIn]="isLoggedIn"
          [showThemeTooltip]="true"
          [hideButtonLightMode]="themeService.hideButtonLightMode()"
          [showCrmButton]="showCrmButton"
          [inSubheader]="true"
          (itemClick)="onItemClick($event)"
          (themeToggle)="toggleTheme()"
        ></app-header-overflow-row>
      </div>
    </div>
  </ng-template>

  <!-- Shared login content template for overflow columns -->
  <ng-template #loginTpl>
    <app-authentication-field></app-authentication-field>
  </ng-template>
</div>

